import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface partnerStateType{
    searchKeyword:string;
    filters:{
        status:string;
        eventType:string[];
        chef:string;
        bookingStatus:string;
        requermentType:string[];
    };
    startDate:string;
    endDate:string;
    offset:number;
}

const FILTERS_MODEL = {
    status:'',
    eventType:[],
    chef:'',
    bookingStatus:'',
    requermentType:[],
};

const initialState: partnerStateType = {
    searchKeyword:'',
    filters: FILTERS_MODEL,
    startDate:'',
    endDate:'',
    offset:0,
};

const partnerSlice = createSlice({
    name: "partners",
    initialState,
    reducers: {
        setSearchKeyword(state,action:PayloadAction<{searchKeyword:string}>){
            return {...state,searchKeyword:action.payload.searchKeyword};
        },
        clearSearchKeyword(state){
            return{...state,searchKeyword:''};
        },
        setOffset(state,action:PayloadAction<{Offset:number}>){
            return{...state,offset:action.payload.Offset};
        },
        setFilters(
            state,
            action:PayloadAction<{filters:partnerStateType['filters']}>
        ){
            return {...state,filters:action.payload.filters}; 
        },
        clearFilters(state){
            return {...state,filters:FILTERS_MODEL};
        },
    }
})

export const {setSearchKeyword,clearSearchKeyword,setOffset,clearFilters} = partnerSlice.actions;

export default partnerSlice.reducer;